export const themes = ["scorebook", "ledger", "terminal"] as const;
export type Theme = typeof themes[number];

export function currentTheme(): Theme {
  const requested = new URLSearchParams(location.search).get("theme");
  // Alternate themes remain available through explicit preview URLs only.
  return themes.includes(requested as Theme) ? requested as Theme : "scorebook";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
}
